var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12564_2709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.533 24.0007H15.4663V32.534C15.4663 33.0998 15.6911 33.6424 16.0912 34.0425C16.4913 34.4426 17.0339 34.6673 17.5997 34.6673H22.933V24.0007H16.533ZM30.3997 24.0007H25.0663V34.6673H30.3997C30.9655 34.6673 31.5081 34.4426 31.9082 34.0425C32.3082 33.6424 32.533 33.0998 32.533 32.534V24.0007H30.3997ZM31.2434 18.6673C31.3985 18.1484 31.4737 17.6089 31.4663 17.0673C31.4663 15.0087 29.7917 13.334 27.733 13.334C26.0029 13.334 24.8477 14.9148 24.1021 16.6247C23.3671 15.0087 22.1533 13.334 20.2663 13.334C18.2077 13.334 16.533 15.0087 16.533 17.0673C16.533 17.7031 16.6173 18.2289 16.7559 18.6673H13.333V22.934H22.933V20.8007H25.0663V22.934H34.6663V18.6673H31.2434ZM18.6663 17.0673C18.6663 16.1852 19.3842 15.4673 20.2663 15.4673C21.2135 15.4673 22.0946 17.094 22.6109 18.6673H19.733C19.3341 18.6673 18.6663 18.6673 18.6663 17.0673ZM27.733 15.4673C28.6151 15.4673 29.333 16.1852 29.333 17.0673C29.333 18.6673 28.6653 18.6673 28.2663 18.6673H25.6242C26.1682 16.9863 26.9586 15.4673 27.733 15.4673Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12564_2709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(13.333 13.334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCircleIcon);
export default __webpack_public_path__ + "static/media/gift_circle_icon.3c1c3c0e7aa7ddfd73f381ed130ee849.svg";
export { ForwardRef as ReactComponent };